import React from "react";
import web3Context  from "./web3Context";
import Web3 from 'web3'
import config from "../../config";
import { useState } from "react";
console.log(config)

const Web3State = (props) =>{
    const web3 =new Web3(window.ethereum || config.INFURA.API)
    const state = {
        web3:web3,
        contract: new web3.eth.Contract(config.CONTRACT.ABI,config.CONTRACT.ADDRESS)
    }

    const [web3state, updateweb3State] = useState(state)

    return(
        <web3Context.Provider value={{web3state, updateweb3State}}>
            {props.children}
        </web3Context.Provider>
    )
}


export default Web3State;